import { DISABLE_CREDIT_CARD_LIST } from './types';
import { enableBodyScroll } from '../../util';

const disableCreditCardList = () => {
  enableBodyScroll();
  return { type: DISABLE_CREDIT_CARD_LIST };
};

export default disableCreditCardList;



// WEBPACK FOOTER //
// ./src/actions/modals/disableCreditCardList.js